/**
 * 공통코드 API
 */
import { api } from "@/redworks/api/index";

const COMMCODE_PATH = "/v1/commCode";

// 공통코드 목록 조회 API
function $getCommCodes(param) {
  return api.get(`${COMMCODE_PATH}/all`, { params: param });
}
// 페이징 공통코드 목록 조회 API
function $getPagingCommCodes(param) {
  return api.get(COMMCODE_PATH, { params: param });
}
// 공통코드 상세 조회 API
function $getCommCodeDetail(id) {
  return api.get(`${COMMCODE_PATH}/${id}`);
}
// 공통코드 생성 API
function $createCommCode(param) {
  return api.post(COMMCODE_PATH, param);
}
// 공통코드 수정 API
function $updateCommCode(id, param) {
  return api.put(`${COMMCODE_PATH}/${id}`, param);
}
// 공통코드 삭제 API
function $deleteCommCode(id) {
  return api.delete(`${COMMCODE_PATH}/${id}`);
}

export {
  $getCommCodes,
  $getCommCodeDetail,
  $createCommCode,
  $updateCommCode,
  $deleteCommCode,
  $getPagingCommCodes,
};
